import React, { useEffect, useState } from 'react';
import AddressFinderSelect from '../../shared/select/address-finder'
import Button from '../../shared/button/button';
import CustomDatePicker from '../../shared/date-picker/date-picker';
import Input from '../../shared/input/input';
import Select from '../../shared/select/select';
import Dialog from '../../shared/dialog/dialog';
import { IsPhysiqueAuthorized } from "../../../utils/auth";
import { getTimePeriods, isToday } from '../../../utils/time';
import {BOOKING_TIME_TYPES, BOOKING_TYPES, bookingLabels, datePickerFormat, visitEcommerceItem} from '../constants';
import { Modal } from '../../../../partials/modal';
import useModalState from '../../../hooks/useModalState';
import {useInView} from "react-intersection-observer";
import {add_to_cart, view_item} from "../../../utils/gtm";
import Validators from '../../../utils/validation';

export default function VisitWidget({ handleSubmit, buttonText, patient }) {
  const { isOpen: isOpenCustomAddressModal, openModal: openCustomAddressModal, closeModal: closeCustomAddressModal } = useModalState();
  const isAuth = IsPhysiqueAuthorized();
  const { required } = Validators;
  const { ref } = useInView({
    triggerOnce: false,
    onChange(inView) {
      if (inView) {
        view_item(visitEcommerceItem);
      }
    }
  });
  const [data, setData] = useState({
    date: new Date(),
    timePeriod: BOOKING_TIME_TYPES.ASAP,
    postcode: '',
    address: '',
    longitude: null,
    latitude: null,
    flatField1: '',
    buildingField1: '',
    streetField1: '',
    custom: null
  });
  const modalWidget = new Modal('g-modal-widget');
  const modalSuccess = new Modal('g-modal-success');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (patient && patient.addresses.length > 0) {
      const address = patient.addresses[0].address.postcode;
      setData({ ...data, postcode: address });
    }
  }, [patient]);

  const contactForm = document.querySelector('.hero-form')?.querySelector('.contact-form-modal');
  const timeOptions = getTimePeriods(isToday(data.date));

  useEffect(() => {
    setData({ ...data, timePeriod: timeOptions[0] });
  }, [data.date]);

  const handleAddressChange = (address, fullAddress, postcode) => {
    handleChange('addressAndPostcode', {
      'address': fullAddress,
      'postcode': postcode,
      'longitude': address.longitude,
      'latitude': address.latitude,
      'custom': null
    });
  }

  const handleChange = (name, value) => {
    if (name === 'addressAndPostcode') setError(false);
    if (name === 'addressAndPostcode') {
      setData({
        ...data,
        ...value,
      });
      return;
    }
    setData({
      ...data,
      [name]: value,
    });
  };

  const isDisabled = !data.postcode?.trim();

  const onSubmit = () => {
    if (!isDisabled) {
      add_to_cart(visitEcommerceItem);
      handleSubmit(
        BOOKING_TYPES.VISIT,
        data.date,
        data.timePeriod,
        data.postcode,
        {
          fullAddress: data.address,
          longitude: data.longitude,
          latitude: data.latitude,
          flatField1: data.flatField1,
          buildingField1: data.buildingField1,
          streetField1: data.streetField1,
          custom: data.custom
        }
      )
    }
  };

  const openModal = () => {
    contactForm && modalWidget.openModal();
  };

  if (contactForm) {
    modalSuccess.closeModal();
    modalWidget.closeModal();
    contactForm.addEventListener('wpcf7mailsent', () => {
      modalSuccess.openModal();
      modalWidget.closeModalHandler();
    });
  }

  const onOpenCustomAddressModal = () => {
    handleChange('address', "Can't find my address. Enter manually");
    openCustomAddressModal();
  }
  const isCustomAddressDisabled = !data.postcode?.trim() || !data.flatField1 || !data.buildingField1 || !data.streetField1

  const onSubmitCustomAddress = () => {
    handleChange('custom', true);
    closeCustomAddressModal()
  }

  return (
    <>
      <div className="booking-widget__grid" ref={ref}>
        <h5>{bookingLabels.area}</h5>
        <AddressFinderSelect
          label="Enter Address to get ETA"
          onChange={handleChange}
          onAddressChange={handleAddressChange}
          name="address"
          value={data.address}
          purePlaceholder
          error={error}
        />
        <div className="booking-widget-postcode">
          <span className="booking-widget-postcode__title tpg_b2" onClick={onOpenCustomAddressModal}>
            Can't find my address. Enter manually
          </span>
        </div>
      </div>

      <div className="booking-widget-fields">
        <div className="booking-widget__field-group">
          <div className="booking-date-picker">
            <CustomDatePicker
              minDate={new Date()}
              value={data.date}
              onChange={handleChange}
              name="date"
              format={datePickerFormat.withWeekendDay}
              isRequired={false}
            />
          </div>
          <Select
            className="select-small"
            name="timePeriod"
            value={data.timePeriod}
            onChange={handleChange}
            options={getTimePeriods(isToday(data.date))}
            isRequired={false}
          />
        </div>
      </div>
      <div className="booking-widget__content-button">
        <Button type={isDisabled ? 'default' : 'white'} text={buttonText} onClick={onSubmit} disabled={isDisabled} />
        <div>
          {data.timePeriod === BOOKING_TIME_TYPES.ASAP && <p className="eta-label tpg_b2">{bookingLabels.liveEta}</p>}
          {!isAuth && <p className="eta-label tpg_b2">
            Already a member? <a href="/login" className="login-label tpg_b2">
              Log in
            </a>
          </p>}
        </div>
      </div>
      {isOpenCustomAddressModal && (
        <Dialog onClose={closeCustomAddressModal} className="prescription__modal booking-widget-custom-address__modal">
          <div className="booking-widget-custom-address__form">
            <h4 className="booking-widget-custom-address__form-title">
              Don’t know your address? <br></br> Please enter address details manualy.
            </h4>
            <Input
              label="Postcode"
              value={data.postcode}
              onChange={handleChange}
              name="postcode"
              rules={[required]}
            />
            <Input
              label="Flat/Business"
              value={data.flatField1}
              onChange={handleChange}
              name="flatField1"
              rules={[required]}
            />
            <Input
              label="Building"
              value={data.buildingField1}
              onChange={handleChange}
              name="buildingField1"
              rules={[required]}
            />
            <Input
              label="Street"
              value={data.streetField1}
              onChange={handleChange}
              name="streetField1"
              rules={[required]}
            />
            <Button className="booking-widget-custom-address__form-button" text="Submit" onClick={onSubmitCustomAddress} disabled={isCustomAddressDisabled} />
          </div>
        </Dialog>
      )}
    </>
  );
}
